const TOKEN_KEY = "admin-token";
const ID_KEY = "admin-id";
const ROLE_KEY = "admin-role";

export function getAdminToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export type PortalRole = "admin" | "super_admin";

export function getAdminRole(): PortalRole | null {
  const storedRole = localStorage.getItem(ROLE_KEY);
  if (getAdminToken() && (storedRole === "admin" || storedRole === "super_admin"))
    return storedRole;
  const token = getAdminToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[0].replace(/-/g, "+").replace(/_/g, "/")));
    return payload.role === "admin" || payload.role === "super_admin" ? payload.role : null;
  } catch {
    return null;
  }
}

export function portalHome(): string {
  return getAdminRole() === "admin" ? "/pd-days" : "/admin";
}

export function getAdminID(): string {
  return localStorage.getItem(ID_KEY) || "admin";
}

export function saveAdminSession(token: string, assignedID: string, role: PortalRole): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(ID_KEY, assignedID);
  localStorage.setItem(ROLE_KEY, role);
}

export function clearAdminSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ID_KEY);
  localStorage.removeItem(ROLE_KEY);
}
